import "./base/gsap";

import { runDefault, runLayoutDefault, runComponentDefault, runModuleDefault } from "./utils/runner-functions";

import { initVariables, isTouchDevice } from "./utils/variables";
import { initScroller, requestScrollTriggerRefresh } from "./base/scroll";
import { runLoader } from "./base/loader";
import { initBarba, setPageInitCallback } from "./base/barba";
import { initTransitionCapture } from "./layout/work-video-transition";

async function init() {
    initGlobalScripts();
    initGlobalLayoutScripts();
    initGlobalComponentScripts();
    await initPageScripts();

    await runLoader();

    requestAnimationFrame(() => requestScrollTriggerRefresh(250));

    initTransitionCapture();
    setPageInitCallback(initPageScripts);
    initBarba();
}

function initGlobalScripts() {
    initVariables();
    initScroller();
    runDefault("grid");
    runDefault("link-prefetch");
    runDefault("link-marquee");
}

function initGlobalLayoutScripts() {
    runLayoutDefault("menu");

    if (!isTouchDevice) {
        runLayoutDefault("saver");
    }
}

function initGlobalComponentScripts() {
    runComponentDefault("logo", ".logo");

    if (!isTouchDevice) {
        runComponentDefault("cursor");
    }
}

async function initPageScripts() {
    runDefault("link-prefetch");
    runDefault("link-marquee");

    runLayoutDefault("clients");

    if (!isTouchDevice) {
        runLayoutDefault("header-work-video");
        runLayoutDefault("film-work-listing");
        runLayoutDefault("music-work-listing");
        runLayoutDefault("close-navigation");
    }

    runComponentDefault("btn-hover", ".btn-hover");
    runComponentDefault("video-player", ".video_wrap");
    runComponentDefault("video-player-mix", ".video_wrap[data-video-site='music'] .video_mix");
    runComponentDefault("bpm-range", ".bpm-range");

    if (!isTouchDevice) {
        runComponentDefault("video-card", ".video-card");
    }

    runModuleDefault("hero", ".hero");
    runModuleDefault("about", ".about");
    runModuleDefault("related", ".related");
    runModuleDefault("services", ".services");
    runModuleDefault("library-hover", ".library__tracks");
    runModuleDefault("library-player", "#library-audio-player");
}

function safeInit() {
    requestAnimationFrame(() => setTimeout(init, 1));
}

if (!(document.readyState === "loading")) safeInit();
else document.addEventListener("DOMContentLoaded", safeInit);
